module.exports = __webpack_public_path__ + "static/img/aquaman5_th.79380be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/aquaman5_th.png
// module id = n04P
// module chunks = 1